export default __webpack_public_path__ + "static/media/image.frost-colombo-pvt-limited.57673d83.png";